import Vue from 'vue'

Vue.prototype.$resize = function(url, config) {
  const baseUrl = Vue.prototype.$api.defaults.baseURL
  return `${baseUrl}/images?path=${url}&w=${config.w || ''}&h=${config.h || ''}&f=${config.f || 'cover'}&c=${config.c || 'white'}`
}
